import { render, staticRenderFns } from "./EWMerchantRegistrationApprovedShow.vue?vue&type=template&id=9aaf36d0&"
import script from "./EWMerchantRegistrationApprovedShow.vue?vue&type=script&lang=js&"
export * from "./EWMerchantRegistrationApprovedShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports